<template>
  <div class='InputImgProd'>
    <div class="add-img">
      <button @click="SetModal({ component: 'SelectImg', active: true })">Adicionar imagem</button>
      (500x500px)
    </div>
    <img-icon
    v-if="!SelectedProdEdit.img.length"
    @click="SetModal({ component: 'SelectImg', active: true })" 
    :options="{ width: '180px', height: '160px', color: '#CCCCCC', action: true }"
    />
    <carousel
    v-if="SelectedProdEdit.img.length"
    v-model="currentSlide"
    :items-to-show="1"
    >
      <slide v-for="(img, key) in imgs" :key="key">
        <div class="cont-img">
          <img class="prod-img" :src="img"
          @click="SetModal({ component: 'SelectImg', active: true })" 
          >
        </div>
      </slide>
      <template #addons>
        <navigation />
      </template>
    </carousel>
    <div class="cont-c-nave">
      <Carousel
      v-if="SelectedProdEdit.img.length"
      :items-to-show="5"
      v-model="currentSlide"
      ref="carousel"
      >
        <Slide v-for="(img, key) in imgs" :key="key">
          <div class="cont-pag" @click="slideTo(key)">
            <img class="img-pagination" :src="img"> 
          </div>
        </Slide>
        <template #addons>
          <pagination paginateByItemsToShow="true"/>
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ImgIcon from '../../Icons/ImgIcon'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel'
import api from '@/mixins/api'
export default {
  name: 'InputImgProd',
  components: { ImgIcon, Carousel, Slide, Navigation, Pagination },
  mixins: [api],
  computed: {
    ...mapGetters(['SelectedProdEdit']),
    imgs () {
      return this.SelectedProdEdit.img.map(i => this.api + i.img)
    }
  },
  methods: {
    ...mapActions(['SetModal']),
    slideTo(val) {
      this.currentSlide = val
    }
  },
  data () {
    return {
      currentSlide: 0
    }
  }
}
</script>

<style scoped>
.InputImgProd {
  width: 100%;
}

.prod-img {
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.img-pagination {
  width: 100%;
  height: 100%;
}

.cont-img {
  width: 100%;
  height: 150px;
}

.add-img {
  padding-bottom: 5%;
}

button {
  border: 0;
  font-size: 16px;
  padding: 3%;
  margin: 1%;
  border-radius: 5px;
  background-color: #333333;
  color: #FFFFFF;
  cursor: pointer;
}

.cont-pag {
  width: 50px;
  height: 50px;
  border: thin solid #CCCCCC;
}
</style>
